var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastArrowsMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 323,
    viewBox: "0 0 582 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 543.339,
    y: 212.338,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 543.339 212.338)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 546.321,
    y: 259.338,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 546.321 259.338)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 544.405,
    y: 300.338,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 544.405 300.338)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 546.321,
    y: 234.338,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 546.321 234.338)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 545.321,
    y: 191.192,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 545.321 191.192)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 380.696,
    y: 277.766,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 380.696 277.766)",
    stroke: "#D7544F",
    strokeWidth: 1.67708
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 380.173,
    y: 322.015,
    width: 1.67708,
    height: 2.15625,
    transform: "rotate(-90 380.173 322.015)",
    stroke: "#535354",
    strokeWidth: 1.67708
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M382.689 320.975H392.273",
    stroke: "#535354",
    strokeWidth: 0.479167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M383.689 276.688H389.919",
    stroke: "#535354",
    strokeWidth: 0.479167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M516.539 258.5L546.727 258.5",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M517.662 299.5L544.975 299.5",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M516.732 233.739L546.92 233.739",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M538.898 211.56L546.086 211.56",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M530.094 190.354L545.906 190.354",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M546.117 190.354L566.669 190.354C574.608 190.354 581.044 183.918 581.044 175.979V14.7617C581.044 6.82261 574.608 0.386719 566.669 0.386719H562.836",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M545.336 211.5L566.961 211.5C574.9 211.5 581.336 205.064 581.336 197.125V139.5",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M546.336 258.5L566.961 258.5C574.9 258.5 581.336 252.064 581.336 244.125V142.5",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M546.336 299.5L566.961 299.5C574.9 299.5 581.336 293.064 581.336 285.125V142.5",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M546.336 233.5L566.961 233.5C574.9 233.5 581.336 227.064 581.336 219.125V142.5",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M380.254 277.168H359.191C351.252 277.168 344.816 270.732 344.816 262.793V115.146C344.816 107.207 338.38 100.771 330.441 100.771H37.6706C29.7315 100.771 23.2956 94.3349 23.2956 86.3958V16.0054C23.2956 8.06629 16.8597 1.63037 8.92056 1.63037H0.295563",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M381.012 321.216L367.814 321.215C359.875 321.215 353.439 314.779 353.439 306.84V15.8409C353.439 7.90176 347.003 1.46582 339.064 1.46582H282.043",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastArrowsMd);
export default __webpack_public_path__ + "static/media/last-arrows-md.ee67adb9779df7cb6cca7a7ee508a28b.svg";
export { ForwardRef as ReactComponent };